class Forms {
    constructor() {
        // global class identifier
        this.class = {
            needsValidation: '.needs-validation',
            offcanvasInput: '.js__offcanvas__solr-suggest',
            modalInput: '.js__modal__solr-suggest',
            newsletterSubscriptionFormField: 'input.subscription-email-prefill',
            newsletterSubscriptionFormFieldError: 'input.subscription-email-validation-error',
            searchItem: '.js__search-item',
        };

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
    }

    /**
     * Handle form validations.
     * On any validation error, set "was-validated" class to form
     */
    handleFormValidations() {
        const forms = document.querySelectorAll(this.class.needsValidation);

        if (!forms.length > 0) {
            return;
        }

        // iterate through elements in each form and listen to "invalid" event
        forms.forEach((form) => {
            form.querySelectorAll('select, textarea, input').forEach((formelement) => {
                formelement.addEventListener('invalid', (e) => {
                    if (!form.classList.contains('was-validated')) {
                        form.classList.add('was-validated');
                        form.classList.remove('needs-validation');
                        e.currentTarget.closest('.form-group').classList.remove('is-invalid');
                    }
                    e.currentTarget.closest('.form-group').classList.add('is-invalid');
                });
            });
        });
    }

    /**
     * Set focus on search input
     */
    focusSearchInput() {
        const offcanvasInput = document.querySelector(this.class.offcanvasInput);
        const modalInput = document.querySelector(this.class.modalInput);
        const searchItem = document.querySelector(this.class.searchItem);

        // set autofocus offcanvas input only when search icon is clicked
        if (offcanvasInput && searchItem) {
            searchItem.addEventListener('click', () => {
                document.querySelector('#offcanvas').addEventListener('shown.bs.offcanvas', function setFocus(e) {
                    offcanvasInput.focus();
                    // removes the event listener after focus
                    e.currentTarget.removeEventListener('shown.bs.offcanvas', setFocus);
                });
            });
        }

        if (modalInput) {
            document.querySelector('#searchModal').addEventListener('shown.bs.modal', () => {
                modalInput.focus();
            });
        }

        // removes focus when offcanvas is closed
        document.querySelector('#offcanvas').addEventListener('hidden.bs.offcanvas', () => {
            offcanvasInput.blur();
        });
    }

    /**
     * Prefill Email field from url in newsletter subscription form
     */
    prefillNewsletterSubscriptionForm() {
        const field = document.querySelector(this.class.newsletterSubscriptionFormField);
        const getParameter = 'email';

        if (field) {
            let getValue = '';
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            getValue = urlParams.get(getParameter);
            if (getValue) {
                field.value = getValue;
            }
        }
    }

    /**
     * Display error msg in newsletter subscription form
     */
    errorNewsletterSubscriptionForm() {
        const field = document.querySelector(this.class.newsletterSubscriptionFormFieldError);

        if (field) {
            field.nextElementSibling.style.display = 'block';
        }
    }

    init() {
        this.handleFormValidations();
        this.focusSearchInput();
        this.prefillNewsletterSubscriptionForm();
        this.errorNewsletterSubscriptionForm();
    }
}

export default new Forms();
